import isOnboardingComplete from './isOnboardingComplete'
import getShortName from './getShortName'
import calculateStatistics from './calculateStatistics'
import getValueFromStatistic from './getValueFromStatistic'
import getUserProfileLocation from './getUserProfileLocation'

export default {
	isOnboardingComplete,
	getShortName,
	calculateStatistics,
	getValueFromStatistic,
	getUserProfileLocation
}



// WEBPACK FOOTER //
// ./src/utilities/Data/User/index.js